<template>
  <qx-card-form title="车队信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="140px"
    >
      <section slot="address" slot-scope="prop">
        <ChooseAddressMap v-model="prop.form.address" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
import {
  findAddressName,
} from '@qx/utils';
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
export default {
  components: {
    ChooseAddressMap,
  },
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '手机号码',
            value: 'linkPhone',
            type: 'input',
            disabled: true,
          },
          {
            label: '超管姓名',
            value: 'linkMan',
            type: 'input',
          },
          {
            label: '超管身份证',
            value: 'linkManIdentification',
            type: 'input',
          },
          {
            label: '营业执照',
            value: 'businessLicense',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '企业资质',
            value: 'companyQualifications',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '企业全称',
            value: 'companyName',
            type: 'input',
          },
          {
            label: '企业简称',
            value: 'shortName',
            type: 'input',
          },
          {
            label: '社会信用代码',
            value: 'businessLicenseNo',
            type: 'input',
          },
          {
            label: '企业注册地址',
            value: 'companyAddress',
            type: 'input',
          },
          {
            label: '常用办公地点',
            value: 'address',
            slot: true,
            default: {},
          },
          {
            label: '车队LOGO',
            value: 'logo',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
          linkPhone: [ // 手机号码
            { required: true, message: '请输入手机号码', trigger: 'blur' },
          ],
          linkMan: [ // 超管姓名
            { required: true, message: '请输入超管姓名', trigger: 'blur' },
          ],
          linkManIdentification: [ // 超管身份证
            { required: true, message: '请输入超管身份证', trigger: 'blur' },
          ],
          businessLicense: [ // 营业执照
            { required: true, message: '请选择营业执照', trigger: 'blur' },
          ],
          companyQualifications: [ // 企业资质
            { required: true, message: '请选择企业资质', trigger: 'blur' },
          ],
          companyName: [ // 企业全称
            { required: true, message: '请输入企业全称', trigger: 'blur' },
          ],
          shortName: [ // 企业简称
            { required: true, message: '请输入企业简称', trigger: 'blur' },
          ],
          businessLicenseNo: [ // 社会信用代码
            { required: true, message: '请输入社会信用代码', trigger: 'blur' },
          ],
          companyAddress: [ // 企业注册地址
            { required: true, message: '请输入企业注册地址', trigger: 'blur' },
          ],
          address: [ // 常用办公地点
            { required: true, message: '请选择常用办公地点', trigger: 'blur' },
          ],
          logo: [ // 车队LOGO
            { required: true, message: '请选择车队LOGO', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 营业执照
        if (formData.businessLicense[0]) {
          formData.businessLicenseUrl = formData.businessLicense[0].url;
          formData.businessLicense = formData.businessLicense[0].id;
        } else {
          delete formData.businessLicense;
        }
        // 企业资质
        if (formData.companyQualifications[0]) {
          formData.companyQualificationsUrl = formData.companyQualifications[0].url;
          formData.companyQualifications = formData.companyQualifications[0].id;
        } else {
          delete formData.companyQualifications;
        }
        // 车队LOGO
        if (formData.logo[0]) {
          formData.logoUrl = formData.logo[0].url;
          formData.logo = formData.logo[0].id;
        } else {
          delete formData.logo;
        }
        // 常用办公地点
        if (formData.address.address) {
          const addressName = findAddressName({
            arr: [
              formData.address.provinceId,
              formData.address.cityId,
              formData.address.countryId,
            ],
          });
          formData.provinceId = formData.address.provinceId;
          formData.provinceName = addressName[0];
          formData.cityId = formData.address.cityId;
          formData.cityName = addressName[1];
          formData.districtId = formData.address.countryId;
          formData.districtName = addressName[2];
          formData.address = formData.address.address;
        }
      }
      return formData;
    },

    async sub () {
      const formData = await this.handleSubData();
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async init (data = {}) {
      if (data.tenantInfo) {
        data = data.tenantInfo;
      }
      // 营业执照
      if (data.businessLicense && data.businessLicenseUrl) { // id和地址都有
        data.businessLicense = [{
          id: data.businessLicense,
          url: data.businessLicenseUrl,
        }];
      } else if (data.businessLicense) { // 只有id
        const urlRes = await getFileUrl({
          flowIds: data.businessLicense,
          _GRID_TYPE: 'jq',
        });
        data.businessLicense = [{
          id: data.businessLicense,
          url: urlRes.rows[0] ? urlRes.rows[0].fullPath : '',
        }];
      } else {
        data.businessLicense = [];
      }
      // 企业资质
      if (data.companyQualifications && data.companyQualificationsUrl) { // id和地址都有
        data.companyQualifications = [{
          id: data.companyQualifications,
          url: data.companyQualificationsUrl,
        }];
      } else if (data.companyQualifications) { // 只有id
        const urlRes = await getFileUrl({
          flowIds: data.companyQualifications,
          _GRID_TYPE: 'jq',
        });
        data.companyQualifications = [{
          id: data.companyQualifications,
          url: urlRes.rows[0] ? urlRes.rows[0].fullPath : '',
        }];
      } else {
        data.companyQualifications = [];
      }
      // 车队LOGO
      if (data.logo && data.logoUrl) { // id和地址都有
        data.logo = [{
          id: data.logo,
          url: data.logoUrl,
        }];
      } else if (data.logo) { // 只有id
        const urlRes = await getFileUrl({
          flowIds: data.logo,
          _GRID_TYPE: 'jq',
        });
        data.logo = [{
          id: data.logo,
          url: urlRes.rows[0] ? urlRes.rows[0].fullPath : '',
        }];
      } else {
        data.logo = [];
      }
      // 常用办公地点
      if (data.address) {
        const address = data.address;
        data.address = {
          provinceId: data.provinceId,
          cityId: data.cityId,
          countryId: data.districtId,
          address,
        };
      } else {
        data.address = {};
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
